import React from 'react';
import { useState, useEffect} from 'react';
import { Modal } from 'react-bootstrap';
import { DashboardComponents } from '../../../DashboardComponents';
import { Utils} from '../../../../Utils';
import {useSelector} from 'react-redux';

function FromReportChart({ show,isData=null, handleClose }) {
  let moduleData = useSelector((state) => state?.forms);
  console.log(moduleData);
  let [selectedModule, setSelectedModule] = useState('');
  let [ShowChart, setShowChart] = useState(null);
   
    let [chartDropdownList] = useState(Utils.getChartDropdownList());
        let [selectedChart, setSelectedChart] = useState(isData?.selectedChart || chartDropdownList[0]);

        useEffect(() => {
            Utils.onClickChart(selectedChart, setShowChart, setSelectedChart, DashboardComponents);
          }, []);

    const handleModuleChange = (e) => {
        setSelectedModule(e.target.value);
    }
    return (
        <Modal show={show} onHide={handleClose} size="xl">
            <Modal.Header closeButton>
                <Modal.Title>Add Chart</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <nav className="container-fluid d-block">
                    <div className="row">
                        <div className="col-md-6 mt-2">
                            <div className="mb-3 form-floating">
                                <input
                                    type="text"
                                    className="form-control"
                                    id="componentName"
                                    placeholder="Enter Component Name"
                                    required
                                />
                                <label htmlFor="componentName">Component Name</label>
                            </div>
                            <div className="mb-3 form-floating">
                                <select className="form-select" id="modules" value={selectedModule} onChange={handleModuleChange}>
                                    <option value="">Select Module</option>
                                    {moduleData?.navbarList?.map((x, index) => {
                                        <option key={index} value={x?._id}>{x?.name}</option>
                                    })}
                                </select>
                                <label htmlFor="modules">Module(s)</label>
                            </div>
                            <div className="mb-3 form-floating">
                                <select className="form-select" id="measure">
                                    <option value="">Select Measure</option>
                                    <option value="measure1">Measure 1</option>
                                    <option value="measure2">Measure 2</option>
                                    <option value="measure3">Measure 3</option>
                                </select>
                                <label htmlFor="measure">Measure (y-axis)</label>
                            </div>
                            <div className="mb-3 form-floating">
                                <select className="form-select" id="grouping">
                                    <option value="">Select Grouping</option>
                                    <option value="group1">Group 1</option>
                                    <option value="group2">Group 2</option>
                                    <option value="group3">Group 3</option>
                                </select>
                                <label htmlFor="grouping">Grouping</label>
                            </div>
                        </div>
                 <div className="col-md-6 d-flex flex-column align-items-center">
                            <div className="w-100 d-flex justify-content-end mb-2">
                                <div className="dropdown">
                                    <button className="btn btn-outline-primary dropdown-toggle" type="button" id="chartDropdown" data-bs-toggle="dropdown" aria-expanded="false">
                                        <i className="fas fa-chart-bar me-2"></i> {selectedChart?.name}
                                    </button>
                                    <ul className="dropdown-menu" aria-labelledby="chartDropdown">
                                        {chartDropdownList.map((x, index) => (
                                            <li key={index} onClick={() => Utils.onClickChart(x, setShowChart, setSelectedChart, DashboardComponents)}><a className="dropdown-item"><i className={x.icon}></i>{x?.name}</a></li>
                                        ))}
                                    </ul>
                                </div>
                            </div>
                            <div className="preview-box rounded p-3 border text-center position-relative" style={{ backgroundColor: '#f8f9fa', width: '100%', height: '300px' }}>
                                {/* <span className="text-muted position-absolute start-50 translate-middle-x mb-2">Visual preview will appear once the module is selected</span> */}
                                {ShowChart && <ShowChart isStatic={true}/>}
                            </div>
                        </div>
                    </div>
                </nav>
            </Modal.Body>
        </Modal>
    );
}

export default FromReportChart;
